import { useSnackbar } from 'notistack'
import { useMutation, useQueryClient } from 'react-query'
import { updateCustomer } from '../cm-api/update-customer'

export function useUpdateCustomer({
  onSuccess,
  onError,
}: { onSuccess?: Function; onError?: Function } = {}) {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(updateCustomer, {
    onSuccess: async ({ data }, variables) => {
      const customerId = data.id.toString()
      await queryClient.invalidateQueries(['getCustomerPlan', customerId])
      await queryClient.invalidateQueries(['getCustomer', customerId])
      if (onSuccess) {
        onSuccess(data, variables)
      } else {
        enqueueSnackbar('User is updated', {
          variant: 'success',
          autoHideDuration: 3000,
        })
      }
    },
    onError: (err) => {
      if (onError) {
        onError(err)
      } else {
        enqueueSnackbar('Failed to update', {
          variant: 'error',
          autoHideDuration: 3000,
        })
      }
      console.error('updateCustomer failed: ', err)
    },
  })
}
